import * as Sentry from "@sentry/react";

export default function configureSentry() {
  Sentry.init({
    dsn: "https://9d81fd3968ec48cc8012f3ca682c7dcf@sentry.flexi-apps.com/112",
  });
  return Sentry;
}
